import { render } from "./SobreNos.vue?vue&type=template&id=339060a2&scoped=true"
import script from "./SobreNos.vue?vue&type=script&lang=js"
export * from "./SobreNos.vue?vue&type=script&lang=js"

import "./SobreNos.vue?vue&type=style&index=0&id=339060a2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-339060a2"]])

export default __exports__